import React from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import NursingHomeOrderForm from "./NursingHomeOrderForm";
import NursingHomeOrderFormMobile from "./NursingHomeOrderFormMobile";

const NursinghomePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return isMobile ? <NursingHomeOrderFormMobile /> : <NursingHomeOrderForm />;
};

export default NursinghomePage;
